import React, { useEffect, useRef, useState, useCallback } from "react";
import {
    Table,
    Form,
    Button,
    Col,
    OverlayTrigger,
    Overlay,
    Popover,
    Tooltip,
    Container,
    Row
} from "react-bootstrap";
import { commonService } from "../../../utils/commonService";
import { apiCall } from "../../../utils/axiosService";
import { API_URL } from "../../../utils/apiRoutes";
import { apiResponse } from "../../../utils/apiResponse";
import { useSelectAPIEndpoint } from "../../../utils/useSelectAPIEndpoint";
import moment from "moment";
import NoteIcon from "../../../Assets/Images/CRM/notes.svg";
import darkNoteIcon from "../../../Assets/Images/CRM/darkNotes.svg";
import Loader from "../../Loader/Loader";
import { useParams } from "react-router-dom";
import ticket from "../../../Assets/Images/Revenue-management/tableTicket.svg";
import soldOutIcon from "../../../Assets/Images/Revenue-management/soldout.svg";
import infoIcon from "../../../Assets/Images/Action Icons/infoIcon..svg";
import emailIcon from "../../../Assets/Images/Email.svg";
import downloadIcon from "../../../Assets/Images/Operation/downloadIcon.svg";

import {
    errorToastMessage,
    successToastMessage,
} from "../../../utils/toastMessage";
import { useSelector } from "react-redux";
import WidgetNote from "../WidgetNote";
import Comments from "../ListingComponent/Comments/Comment";
import { FixColumn } from "../../../utils/dataTable";
import EventViewModal from "../../CommonComponent/EventViewModal";
import AddWidgetModal from "../AddWidgetModal";
import FlagPopup from "../ListingComponent/DailySummary/FlagPopup";
import SingleDateSummaryModal from "../SingleDateSummaryModal";
import SingleDayGroupModal from "../SingleDayGroupModal";
import ToolsSummaryModal from "../ToolsSummaryModal";
import Non_WidgetDetailModal from "../NonWidgetDetailModal";
import Skeleton from "../../Skeletons/Skeleton";


const DSDashboard = ({
    fetchAll,
    dependentReqData,
    startDate,
    endDate,
    demandScoreData,
    asOfDate,
    demandLevels,
    loadingDemand,
    api,
    para
}) => {
    const stlyComsetRatesEndpoint = useSelectAPIEndpoint({
        standard: API_URL.DAILY_SUMMARY.STLY_LY_COMSET_RATES,
        datewise: API_URL.DAILY_SUMMARY.STLY_LY_COMSET_RATES_DATEWISE
    });
    
    const eventListRef = useRef();
    const userDetail = commonService.getLoginUserData();
    const dummyData = [
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
        {
            date: "2023-08-01",
            OOO: 0,
            RoomAvailable: 0,
            LeftToSell: 0,
            avgleadtime: 0,
            OnTheBook: 0,
            TotalOCCPercentage: 0,
            ADR: 0,
            REV: 0,
            RevPAR: 0,
            OTB: 0,
            Block: 0,
            RMS: 0,
            ADR: 0,
        },
    ];
    let ooo = 0,
        RmsAvailable = 0,
        leftToSell = 0,
        avgleadtime = 0,
        otb = 0,
        occPercentage = 0,
        adr = 0,
        rev = 0,
        revPar = 0,
        groupOTB = 0,
        groupBlock = 0,
        pickupRooms = 0,
        pickupAdr = 0,
        dayName = false,
        barBasedOTB = 0,
        baeBasedRollingAvg = 0,
        pickupAdrCount = 0,

        threePickupRooms = 0,
        threePickupAdr = 0,
        threePickupAdrCount = 0,
        threePickupRev = 0,

        sevenPickupRooms = 0,
        sevenPickupAdr = 0,
        sevenPickupAdrCount = 0,
        pickupRev = 0,
        sevenPickupRev = 0,
        Total_STLY_ADR_Count = 0,
        Total_STLY_ADR = 0,
        Total_STLY_OTB = 0,
        Total_STLY_Revenue = 0,
        Total_STLY_AVG_Lead_Time = 0,
        Total_STLY_AVG_Lead_Time_Count = 0,
        Total_STLY_AVG_Rate = 0,
        Total_LY_ADR_Count = 0,
        Total_LY_ADR = 0,
        Total_LY_OTB = 0,
        Total_LY_Revenue = 0,
        Total_LY_AVG_Lead_Time = 0,
        Total_LY_AVG_Lead_Time_Count = 0,
        Total_LY_AVG_Rate = 0;


    const initTotalPickup = {
        "pick_rms": 0,
        "pick_adr": 0,
        "pick_rev": 0
    }

    const date = new Date();

    const asOfDateFromRTK = useSelector((store) => store.headerProperty.asOfDate);
    const [orgData, setOrgData] = useState(null);
    const [loading, setLoading] = useState(loadingDemand);
    const [selectAsOfDate, setSelectAsOfDate] = useState();
    const [startRangeDate, setStartRangeDate] = useState();
    const [endRangeDate, setEndRangeDate] = useState();
    const [selectPickupDate, setSelectPickupDate] = useState();
    const [selectSevenPickupDate, setSelectSevenPickupDate] = useState();
    const [selectThreePickupDate, setSelectThreePickupDate] = useState();
    const [pickupFromData, setPickupFromData] = useState(null);
    const [pickupFromDataTotal, setPickupFromDataTotal] = useState(initTotalPickup);
    const [sevenPickupFromDataTotal, setSevenPickupFromDataTotal] = useState(initTotalPickup);
    const [threePickupFromDataTotal, setThreePickupFromDataTotal] = useState(initTotalPickup);
    const [sevenPickupFromData, setSevenPickupFromData] = useState(null);
    const [threePickupFromData, setThreePickupFromData] = useState(null);
    const [rateShopListData, setRateShopListData] = useState(null);
    const [past_rateShopListData, setPast_rateShopListData] = useState([]);
    const [maxDateForPickupFrom, setMaxDateForPickupFrom] = useState();
    const [showSingleDate, setShowSingleDate] = useState(false);
    const maxDateRef = useRef();
    const sevenMaxDateRef = useRef();
    const threeMaxDateRef = useRef();
    const singleDatePickupDateRef = useRef();
    const singleDateSelectedDateRef = useRef();
    const selectedTdIndexRef = useRef();
    const dateForNoteRef = useRef();
    const userNoteRef = useRef();
    const eventListPropsRef = useRef();
    const [showTicketModal, setShowTicketModal] = useState(false);
    const [noteUpdate, setNoteUpdate] = useState(false);
    const [noteLoading, setNoteLoading] = useState(false);
    if (maxDateForPickupFrom) {
        let date = new Date(maxDateForPickupFrom);
        let sevenDate = new Date(maxDateForPickupFrom);
        let threeDate = new Date(maxDateForPickupFrom);
        maxDateRef.current = date.setDate(date.getDate() - 1);
        sevenMaxDateRef.current = sevenDate.setDate(sevenDate.getDate() - 7);
        threeMaxDateRef.current = threeDate.setDate(threeDate.getDate() - 3);
    }
    const startDateArrayRef = useRef([]);
    const [forecastData, setForecastData] = useState(null);
    const [forecastLoading, setForecastLoading] = useState(null);

    const [barBasedData, setBarBasedData] = useState(null);
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    const [selectedForecast, setSelectedForecast] = useState(propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term ? propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term.toLowerCase() : "ema");
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );
    const [widgetModal, setWidgetModal] = useState(false);
    const [flagModal, setFlagModal] = useState(false);
    const [flagModalData, setFlagModalData] = useState({});
    const widgetDetailRef = useRef();
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const [addNoteModal, setAddNoteModal] = useState(false);
    const closeNoteModal = () => {
        setAddNoteModal(false);
    };
    const [activePresetRange, setActivePresetRange] = useState(null);
    const [openDatePicker, setOpenDatePicker] = useState(false);
    const clickedDateForNote = useRef();
    const [noteDetail, setNoteDetail] = useState(null);
    const selectedEventDateRef = useRef();
    const [showToolsSummaryModal, setToolsSummaryModal] = useState(false);
    const [ClickedDate, setClickedDate] = useState(new Date());

    const closeToolsSummaryModal = () => {
        setToolsSummaryModal(false);
    };



    const htmlToText = (html) => {
        const tempElement = document.createElement("div");
        tempElement.innerHTML = html;
        const plainText = tempElement.innerText;
        return plainText;
    };

    const closeTicketModal = () => {
        setShowTicketModal(false);
    };

    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

    const diffDayInTime = new Date(endDate).getTime() - new Date(startDate).getTime();
    const diffDays = diffDayInTime / (1000 * 3600 * 24);

    const getEventList = async () => {
        let eventList = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: parseInt(propertyDetailFromRTK?.propertyid),
                    startdate: null,
                    enddate: null,
                    eventname: "",
                    eventtypeterm: "",
                    yearterm: ``,
                },
            },
            false
        );

        let eventListResponse = apiResponse(false, eventList);

        if (eventListResponse?.isValidate) {
            let eventListArr = [];

            eventListResponse?.data?.data?.forEach((item) => {
                try {
                    let singleEventObj = {
                        id: item?.eventid ? item?.eventid : 0,
                        name: item?.eventname,
                        detail: item?.eventdetails,
                        startDate: item?.startdate,
                        endDate: item?.enddate,
                        eventJson: item?.eventjson,
                        eventResourceId: item?.eventsourceid,
                    };
                    let eventJsonData = "";
                    if (item?.eventjson) {
                        var decodedString = decodeURIComponent(item?.eventjson);
                        const jsonStringWithoutQuotes = decodedString.slice(1, -1);
                        const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
                        eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
                        let desc = eventJsonData?.description?.replaceAll("+", " ");
                        singleEventObj = {
                            ...singleEventObj,
                            labels: eventJsonData?.labels ? eventJsonData?.labels : "",
                            rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
                            local_rank: eventJsonData?.local_rank
                                ? eventJsonData?.local_rank
                                : 0,
                            phq_attendance: eventJsonData?.phq_attendance
                                ? eventJsonData?.phq_attendance
                                : 0,
                            geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
                            geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
                            detail: desc,
                        };
                    }
                    eventListArr.push(singleEventObj);
                } catch (err) { }
            });
            eventListRef.current = eventListArr;
        }

        if (!eventListResponse?.isValidate) {
            eventListRef.current = [];
        }
    };




    const getORGDetail = async () => {
        setLoading(true);

        await getEventList();

        let orgDetailResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.ORG,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : asOfDate,
                    startDate: startDate,
                    endDate: endDate,
                    propertyCode: propertyDetailFromRTK?.propertycode,
                },
            },
            false
        );

        let response = apiResponse(false, orgDetailResponse);

        if (response?.isValidate) {
            setOrgData(response?.data?.data);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setOrgData(dummyData);
            setLoading(false);
        }
    };

    const getPickupFromData = async () => {
        setLoading(true);
        let pickupDate = new Date(asOfDate);
        pickupDate.setDate(pickupDate.getDate() - 1);
        singleDatePickupDateRef.current = pickupDate;
        let pickupFromDataResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.PICKUP_FROM,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : asOfDate,
                    startDate: startDate,
                    endDate: endDate,
                    pickupDate: selectPickupDate
                        ? moment(selectPickupDate).format("YYYY-MM-DD")
                        : moment(pickupDate).format("YYYY-MM-DD"),
                    propertyCode: propertyDetailFromRTK?.propertycode,
                    ForcastType: propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term ? propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term.toLowerCase() : "ema"
                },
            },
            false
        );

        let response = apiResponse(false, pickupFromDataResponse);

        if (response?.isValidate) {
            let pickupFromData = response?.data?.data?.data?.map((item, index) => {
                // let dateForTd = new Date(
                //   startDateFromParent ? startDateFromParent : startDate
                // );
                // item.date = commonService.getDateInDBFormat(
                //   dateForTd.setDate(dateForTd.getDate() + index)
                // );

                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index)
                );
                return item;
            });
            setPickupFromDataTotal(response?.data?.data?.total_pickup?.[0])
            setPickupFromData(pickupFromData);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setPickupFromDataTotal(initTotalPickup)
            setLoading(false);
            setPickupFromData(null);
        }
    };

    const [STLY_LY_COMSET_Rates, setSTLY_LY_COMSET_Rates] = useState(null);

    const getsetSTLY_LY_COMSET_Rates = async () => {
        setLoading(true);
        let pickupDate = new Date(asOfDate);
        pickupDate.setDate(pickupDate.getDate() - 1);
        singleDatePickupDateRef.current = pickupDate;
        let ComsetRatesResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    stlyComsetRatesEndpoint,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : asOfDate,
                    startDate: startDate,
                    endDate: endDate,
                    propertyCode: propertyDetailFromRTK?.propertycode,
                },
            },
            false
        );

        let response = apiResponse(false, ComsetRatesResponse);

        if (response?.isValidate) {
            setSTLY_LY_COMSET_Rates(response?.data?.data);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setLoading(false);
            setSTLY_LY_COMSET_Rates(null);
        }
    };

    const getSevenPickupFromData = async () => {

        setLoading(true);
        let pickupDate = new Date(asOfDate);
        pickupDate.setDate(pickupDate.getDate() - 7);
        let pickupFromDataResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.PICKUP_FROM,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : asOfDate,
                    startDate: startDate,
                    endDate: endDate,
                    pickupDate: selectSevenPickupDate
                        ? moment(selectSevenPickupDate).format("YYYY-MM-DD")
                        : moment(pickupDate).format("YYYY-MM-DD"),
                    propertyCode: propertyDetailFromRTK?.propertycode,
                    ForcastType: propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term ? propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term.toLowerCase() : "ema"
                },
            },
            false
        );

        let response = apiResponse(false, pickupFromDataResponse);

        if (response?.isValidate) {
            let pickupFromData = response?.data?.data?.data?.map((item, index) => {
                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index)
                );
                return item;
            });

            setSevenPickupFromDataTotal(response?.data?.data?.total_pickup?.[0]);
            setSevenPickupFromData(pickupFromData);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setSevenPickupFromDataTotal(initTotalPickup);
            setLoading(false);
            setSevenPickupFromData(null);
        }
    };


    const getThreePickupFromData = async () => {

        setLoading(true);
        let pickupDate = new Date(asOfDate);
        pickupDate.setDate(pickupDate.getDate() - 3);
        let pickupFromDataResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.PICKUP_FROM,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : asOfDate,
                    startDate: startDate,
                    endDate: endDate,
                    pickupDate: selectThreePickupDate
                        ? moment(selectThreePickupDate).format("YYYY-MM-DD")
                        : moment(pickupDate).format("YYYY-MM-DD"),
                    propertyCode: propertyDetailFromRTK?.propertycode,
                    ForcastType: propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term ? propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term.toLowerCase() : "ema"
                },
            },
            false
        );

        let response = apiResponse(false, pickupFromDataResponse);

        if (response?.isValidate) {
            let pickupFromData = response?.data?.data?.data?.map((item, index) => {
                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index)
                );
                return item;
            });
            setThreePickupFromDataTotal(response?.data?.data?.total_pickup?.[0]);
            setThreePickupFromData(pickupFromData);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setThreePickupFromDataTotal(initTotalPickup);
            setLoading(false);
            setThreePickupFromData(null);
        }
    };

    const rateShopListAsOfDate = async () => {
        setLoading(true);

        let byPropertyIdResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_SHOP_CONFIG.GET_BY_PROPERTY_ID,
                body: {
                    id: propertyDetailFromRTK?.propertyid,
                },
            },
            false
        );

        let propertyResponse = apiResponse(false, byPropertyIdResponse);

        let CompareDate = new Date(selectAsOfDate ? selectAsOfDate : asOfDate);
        CompareDate = CompareDate.setDate(CompareDate.getDate() - 1)

        let rateShopListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.RATESHOP_LIST,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : asOfDate,
                    propertyCode: propertyDetailFromRTK?.propertycode,
                    Channel: propertyResponse?.data?.data?.channel_term
                        ? propertyResponse?.data?.data?.channel_term
                        : "",
                    startDate: startDate,
                    endDate: endDate,
                    propertyid: propertyDetailFromRTK?.propertyid,
                    CompareDate: CompareDate ? commonService.getDateInDBFormat(CompareDate) : "",
                },
            },
            false
        );

        let response = apiResponse(false, rateShopListResponse);
        if (response?.isValidate) {
            let rateShopData = response?.data?.data?.map((item, index) => {
                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index)
                );
                return item;
            });
            setRateShopListData(rateShopData);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setRateShopListData(null);
            setLoading(false);
        }
    };

    const past_rateShopListAsOfDate = async () => {
        setLoading(true);

        let byPropertyIdResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_SHOP_CONFIG.GET_BY_PROPERTY_ID,
                body: {
                    id: propertyDetailFromRTK?.propertyid,
                },
            },
            false
        );

        let propertyResponse = apiResponse(false, byPropertyIdResponse);
        let PevAsOfDate = new Date(selectAsOfDate ? selectAsOfDate : asOfDate);
        PevAsOfDate = new Date(date.setDate(PevAsOfDate.getDate() - 1));
        let rateShopListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.PAST_RATESHOP_LIST,
                body: {
                    AsOfDate: commonService.getDateForNode(PevAsOfDate),
                    propertyCode: propertyDetailFromRTK?.propertycode,
                    Channel: propertyResponse?.data?.data?.channel_term
                        ? propertyResponse?.data?.data?.channel_term
                        : "",
                    startDate: startDate,
                    endDate: endDate,
                    propertyid: propertyDetailFromRTK?.propertyid,
                },
            },
            false
        );

        let response = apiResponse(false, rateShopListResponse);
        if (response?.isValidate) {
            let rateShopData = response?.data?.data?.map((item, index) => {
                let dateForTd = startRangeDate
                    ? new Date(startRangeDate)
                    : new Date(startDate);
                item.date = commonService.getDateInDBFormat(
                    dateForTd.setDate(dateForTd.getDate() + index)
                );
                return item;
            });
            setPast_rateShopListData(rateShopData);
            setLoading(false);
        }

        if (!response?.isValidate) {
            setPast_rateShopListData([]);
            setLoading(false);
        }
    };


    const saveNote = async () => {
        let saveResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.SAVE_UPDATE,
                body: {
                    propertyCode: propertyDetailFromRTK?.propertycode,
                    Dates: dateForNoteRef.current,
                    UserNotes: userNoteRef.current,
                },
            },
            false
        );

        let response = apiResponse(true, saveResponse, setNoteLoading);

        if (response?.isValidate) {
            // successToastMessage(response?.data?.message);
            // setNoteUpdate(!noteUpdate);
        }
        if (!response?.isValidate) {
            errorToastMessage(response?.data?.message);
            // setNoteUpdate(!noteUpdate);
        }
    };

    const getForecastDetail = async () => {
        setForecastLoading(true);
        let forecastResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DAILY_SUMMARY.PRICING_FORECAST,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : asOfDate,
                    startDate: startDate,
                    endDate: endDate,
                    propertyCode: propertyDetailFromRTK?.propertycode,
                    propertyid: propertyDetailFromRTK?.propertyid,
                    ForcastType: (selectedForecast ? selectedForecast : "ema").toLowerCase(),
                },
            },
            false
        );

        let response = apiResponse(false, forecastResponse);

        if (response?.isValidate) {
            setForecastData(response?.data?.data);
            setForecastLoading(false);
        }

        if (!response?.isValidate) {
            setForecastData([]);
            setForecastLoading(false);
        }
    };

    const getBarBasedDetail = async () => {
        let barBasedResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.BAR_BASED_STATS,
                body: {
                    AsOfDate: selectAsOfDate ? selectAsOfDate : asOfDate,
                    startDate: startDate,
                    endDate: endDate,
                    propertyCode: propertyDetailFromRTK?.propertycode,
                },
            },
            false
        );

        let response = apiResponse(false, barBasedResponse);

        if (response?.isValidate) {
            setBarBasedData(response?.data?.data);
        }
        if (!response?.isValidate) {
            setBarBasedData(null);
        }
    };

    const getNoteByDataList = async () => {
        let noteByDataListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.Configuration +
                    API_URL.WIDGET_NOTE.GET_BY_DATA_LIST,
                body: {
                    propertyid: propertyDetailFromRTK?.propertyid,

                    widgetid: 0,
                    startdate: commonService.getDateInDBFormat(startDate),
                    enddate: commonService.getDateInDBFormat(endDate),
                },
            },
            false
        );

        let response = apiResponse(false, noteByDataListResponse);

        if (response?.isValidate) {
            setNoteDetail(response?.data?.data);
        }

        if (!response?.isValidate) {
            setNoteDetail(null);
        }
    };

    const callBothApi = () => {
        getORGDetail();
        getPickupFromData();
        getSevenPickupFromData();
        getThreePickupFromData();
        rateShopListAsOfDate();
        past_rateShopListAsOfDate();
        getForecastDetail();
        getBarBasedDetail();
        getNoteByDataList();
        getsetSTLY_LY_COMSET_Rates();
    };

    useEffect(() => {
        if (asOfDate && startDate && endDate) {
            // getORGDetail();
            let datesArr = commonService.getDateBetweenTwoDates(
                commonService.convertDateInTimezone(
                    startDate
                ),
                commonService.convertDateInTimezone(
                    endDate
                )
            );
            startDateArrayRef.current = datesArr;

            setMaxDateForPickupFrom(new Date(asOfDate));
            callBothApi();
        }
        if (!selectAsOfDate) {
            setSelectAsOfDate(asOfDate);
        }
    }, [startDate, endDate, asOfDate, selectAsOfDate, selectedForecast]);

    useEffect(() => {
        setSelectAsOfDate(asOfDateFromRTK);
    }, [asOfDateFromRTK]);

    useEffect(() => {
        if (selectPickupDate) {
            getPickupFromData();
        }
    }, [selectPickupDate]);
    useEffect(() => {
        if (selectSevenPickupDate) {
            getSevenPickupFromData();
        }
    }, [selectSevenPickupDate]);


    useEffect(() => {
        if (selectThreePickupDate) {
            getThreePickupFromData();
        }
    }, [selectThreePickupDate]);





    const [tblids, settblids] = useState({
        OrgStrategyTable: commonService.GenerateGUID(),
    });
    //commonService.setBackColorPerByTDValue(
    //    "#638EC6",
    //    "Red",
    //    `#${tblids.OrgStrategyTable} .perbackground-otb`
    //);
    //commonService.setBackColorPerByTDValue(
    //    "Green",
    //    "Red",
    //    `#${tblids.OrgStrategyTable} .perbackground-adr`
    //);

    commonService.setBackColorPerByTDValueInPercentage(
        "Green",
        "Red",
        `#${tblids.OrgStrategyTable} .TotalOCCPercentage`
    );


    commonService.setBackColorPerByTDValueInPercentage(
        "#FFDEA1",
        "Red",
        `#${tblids.OrgStrategyTable} .perbackground-GroupOTB`
    );


    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.OrgStrategyTable} .perbackground-room`
    );


    const [ONTHEBOOKS, setONTHEBOOKS] = useState({
        IsDisplay: false,
        // Property: { top: 0, left: 0 },
        Target: null,
        Position: "top",
    });
    const orgStrategyTableRef = useRef(null);
    const [groupModal, setGroupModal] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });
    useEffect(() => {
        if (orgStrategyTableRef.current) {
            orgStrategyTableRef.current.addEventListener(
                "click",
                handleOrgStrategyTableClick
            );
        }

        return () => {
            if (orgStrategyTableRef.current) {
                orgStrategyTableRef.current.removeEventListener(
                    "click",
                    handleOrgStrategyTableClick
                );
            }
        };
    }, []);

    const handleOrgStrategyTableClick = (event) => { };

    const handleFilterBtnClick = (event) => {
        // let screenY = event.screenY;
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        // let Left = event.nativeEvent.layerX + 30;
        if (Top + 400 > window.innerHeight) {
            // Top = Top - 400;
            Position = "top";
        }
        setONTHEBOOKS({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };
    const closeSingleDate = () => {
        selectedTdIndexRef.current = -1;
        // setONTHEBOOKS({ IsDisplay: false, Property: { top: 0, left: 0 } });
        setONTHEBOOKS({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    const handleGroupBtnClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setGroupModal({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const closeGroupDate = () => {
        selectedTdIndexRef.current = -1;
        setGroupModal({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };



    FixColumn(tblids.OrgStrategyTable, [1, 2]);

    const renderTooltip = (message, item) => (
        <Popover id="popover-id" className="tooltip-flag">
            <div className="m-2">{message}</div>
            <div className="d-flex justify-content-center mb-2">
                <Button id={commonService.generateGlobalClickTrackerID("DSDashboard", "ask-rm-copilot", item)}
                    onClick={() => {
                        setFlagModal(true);
                        setFlagModalData({
                            asofdate: asOfDate,
                            dates: item,
                            propertycode: propertyDetailFromRTK?.propertycode,
                        });
                    }}
                >
                    Ask RM Copilot
                </Button>
            </div>
        </Popover>
    );

    const safeDivide = (a, b) => (b ? a / b : 0);


    const demandLevelConfig = {
        VERYHIGH: {
            label: "Very High",
            bg: "#1B9E4B",
            text: "#FFFFFF",
            key: "veryhigh",
        },
        HIGH: { label: "High", bg: "#2E7D32", text: "#FFFFFF", key: "high" },
        MODERATE: {
            label: "Moderate",
            bg: "#E5A819",
            text: "#000000",
            key: "moderate",
        },
        MEDIUM: {
            label: "Moderate",
            bg: "#E5A819",
            text: "#000000",
            key: "moderate",
        }, // alias
        LOW: { label: "Low", bg: "#E07416", text: "#FFFFFF", key: "low" },
        VERYLOW: {
            label: "Very Low",
            bg: "#C62828",
            text: "#FFFFFF",
            key: "verylow",
        },
    };

    // Fallback for unknown / missing values
    const defaultLevel = {
        label: "—",
        bg: "#555555",
        text: "#FFFFFF",
        key: "unknown",
    };


    const getLevelFromTag = (tag) => {
        const upperTag = String(tag || "")
            .trim()
            .toUpperCase();
        return demandLevelConfig[upperTag] || defaultLevel;
    };

    const kpiMetrics = useCallback(() => {
        if (!demandScoreData || demandScoreData.length === 0) {
            return {
                avgScore: "0.0",
                veryHighHigh: 0,
                moderate: 0,
                lowVeryLow: 0,
                avgCF: "0.00",
                avgOTBOcc: 0,
                kpisActive: dependentReqData?.kpiData?.length || 0,
            };
        }

        let scoreSum = 0;
        let cfSum = 0;
        let levelCounts = { veryhigh: 0, high: 0, moderate: 0, low: 0, verylow: 0 };

        demandScoreData.forEach((item) => {
            const demand = Math.round(item.finaldemandscore) || 0;
            const adjCF = item.adj_cf === "NaN" ? 0 : Number(item.adj_cf) || 0;

            scoreSum += demand;
            cfSum += adjCF;

            // Use demandtag string for level counting
            const { key } = getLevelFromTag(item.demandtag);
            if (key in levelCounts) {
                levelCounts[key]++;
            }
        });

        const count = demandScoreData.length;
        let avgOTBOcc = 0;
        if (orgData) {
            let RmsAvailable = orgData.reduce((sum, item) => sum + (item.RoomAvailable ? parseInt(item.RoomAvailable) : 0), 0)
            let otb = orgData.reduce((sum, item) => sum + (item.OnTheBook ? parseInt(item.OnTheBook) : 0), 0)
            avgOTBOcc = Math.round((otb / RmsAvailable) * 100)
        }

        return {
            avgScore: count > 0 ? (scoreSum / count).toFixed(1) : "0.0",
            veryHighHigh: levelCounts.veryhigh + levelCounts.high,
            moderate: levelCounts.moderate,
            lowVeryLow: levelCounts.low + levelCounts.verylow,
            avgCF: count > 0 ? (cfSum / count).toFixed(2) : "0.00",
            avgOTBOcc: avgOTBOcc,
            kpisActive: dependentReqData?.kpiData?.length || 0,
        };
    }, [demandScoreData, dependentReqData, endDate, orgData]);

    const metrics = kpiMetrics();

    const KPICard = ({ title, value, subtitle, color }) => (
        <div
            className="kpi-card"
            style={{
                padding: "12px",
                borderRadius: "8px",
                background: "rgba(53, 101, 252, 0.1)",
                border: "1px solid rgba(53, 101, 252, 0.2)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                textAlign: "center"
            }}
        >
            <div
                style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                }}
            >
                {title}
            </div>
            <div
                style={{ fontSize: "24px", fontWeight: 700, color: color || "#00D9FF" }}
            >
                {value}
            </div>
            <div style={{ fontSize: "12px" }}>{subtitle}</div>
        </div>
    );

    return (
        <div className="ds-dashboard-tab">


            {propertyDetailFromRTK ? (
                <Container fluid>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
                            gap: "12px",
                            marginTop: "16px",
                            marginBottom: "16px",
                        }}
                    >
                        {loading ? (
                            <Skeleton skeletonType="DSDashboardCards" />
                        ) : (
                            <>
                                <KPICard
                                    title="AVG SCORE"
                                    value={metrics.avgScore}
                                    subtitle="Demand Level"
                                    color="#00D9FF"
                                />
                                <KPICard
                                    title="VERY HIGH+HIGH"
                                    value={metrics.veryHighHigh}
                                    subtitle={`${demandScoreData?.length || 0} dates`}
                                    color="#1B9E4B"
                                />
                                <KPICard
                                    title="MODERATE"
                                    value={metrics.moderate}
                                    subtitle="of dates"
                                    color="#E5A819"
                                />
                                <KPICard
                                    title="LOW+VERY LOW"
                                    value={metrics.lowVeryLow}
                                    subtitle=""
                                    color="#D32F2F"
                                />
                                <KPICard
                                    title="AVG CF"
                                    value={metrics.avgCF}
                                    subtitle="Risk 7%"
                                    color="#FF9800"
                                />
                                <KPICard
                                    title="AVG OTB OCC"
                                    value={`${metrics.avgOTBOcc}%`}
                                    subtitle="ADR $150"
                                    color="#00D9FF"
                                />
                                <KPICard
                                    title="KPIS ACTIVE"
                                    value={metrics.kpisActive}
                                    subtitle="KPI Model"
                                    color="#1B9E4B"
                                />
                            </>
                        )}
                    </div>

                    <div className="mt-1 mb-1">
                        <h6
                            style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                marginBottom: "15px",
                            }}
                        >
                            Demand Score — Date Grid (All{" "}
                            {dependentReqData?.kpiData?.length || 0} KPIs)
                            <span style={{ float: "right", fontSize: "12px" }}>
                                {demandScoreData?.length || 0} dates ×{" "}
                                {dependentReqData?.kpiData?.length || 0} KPIs
                            </span>
                        </h6>
                    </div>
                    <div className="widget-container snapshotrow" style={{ position: "relative", padding: "0 5px" }} rowtitle="Demand Score">
                        <div className="gap-1 widget-container-menu">
                            <Button className="heading-menu-btns" type="button">
                                <img id={commonService.generateGlobalClickTrackerID("DSDashboard", "info", "")}
                                    src={infoIcon}
                                    alt="info"
                                    onClick={() => {
                                        widgetDetailRef.current = {
                                            widgetdetails: "",
                                            usernote: "",
                                            compName: "Demand Score",
                                            widgetId: 0,
                                        };
                                        setWidgetModal(true);
                                    }}
                                />
                            </Button>
                            <Button className="heading-menu-btns" type="button">
                                <img id={commonService.generateGlobalClickTrackerID("DSDashboard", "menuicon", "")}
                                    src={downloadIcon}
                                    alt="menuIcon"
                                    import={tblids.OrgStrategyTable}
                                    onClick={() =>
                                        commonService.fnExportInCSV(
                                            tblids.OrgStrategyTable,
                                            `${propertyDetailFromRTK?.propertycode}-DemandScore-${moment(
                                                new Date()
                                            ).format("MMDDYYYY")}`
                                        )
                                    }
                                />
                            </Button>
                        </div>
                        <Row>
                            <Col lg={12}>
                                <div className="ViewPropertySetupTable mb-3">
                                    <div>
                                        <div className="RoomsPercentilesData">
                                            <p>Demand Score</p>
                                            <div>
                                                <p className="px-3 demandscorecolor-verylow">Very Low ({demandLevels.verylow} - {demandLevels.low - 1})</p>
                                            </div>
                                            <div>
                                                <p className="px-3 demandscorecolor-low">Low ({demandLevels.low} - {demandLevels.moderate - 1})</p>
                                            </div>
                                            <div>
                                                <p className="px-3 demandscorecolor-moderate">Moderate ({demandLevels.moderate} - {demandLevels.high - 1})</p>
                                            </div>
                                            <div>
                                                <p className="px-3 demandscorecolor-high">High ({demandLevels.high} - {demandLevels.veryhigh - 1})</p>
                                            </div>
                                            <div>
                                                <p className="px-3 demandscorecolor-veryhigh">Very High ({demandLevels.veryhigh} - 100)</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="stripped__table">
                                        <div className="table-responsive tblDynamicPickupSticky">
                                            <Table
                                                id={tblids.OrgStrategyTable}
                                                className="table-with-spacing positionStaticTable dailySummaryTbl"
                                                ref={orgStrategyTableRef}
                                            >
                                                <thead className="tbl-header-sticky">
                                                    <tr className="diff-bg-tr table-main-header-tr">
                                                        <th className="width150" >

                                                        </th>

                                                        <th className="border-right text-center border-right-1 width100" >

                                                        </th>


                                                        <th className=" text-center" colSpan={6}>
                                                            TRANSIENT CURRENT YEAR
                                                        </th>
                                                        <th className="border-right text-center" colSpan={2}>
                                                            Revenue
                                                        </th>
                                                        <th className="border-right text-center">Group</th>
                                                        <th className="border-right text-center" colSpan={2}>
                                                            Bar Based Stats
                                                        </th>
                                                        <th className="border-right text-center" colSpan={4}>
                                                            STLY
                                                        </th>
                                                        <th className="border-right text-center" colSpan={4}>
                                                            LY
                                                        </th>
                                                        <th className="border-right width100 text-center" colSpan={3}>
                                                            <div className="">
                                                                <span>1 Day Pickup</span>

                                                            </div>
                                                        </th>

                                                        <th className="border-right width100 text-center" colSpan={3}>
                                                            <div className="">
                                                                <span>3 Day Pickup</span>

                                                            </div>
                                                        </th>

                                                        <th className="border-right width100 text-center" colSpan={3}>
                                                            <div className="">
                                                                <span>7 Day Pickup</span>
                                                            </div>
                                                        </th>

                                                        <th className="text-center border-right" colSpan={3}>
                                                            Pricing & Forecast
                                                        </th>
                                                        {rateShopListData && (
                                                            <th
                                                                colSpan={6
                                                                }
                                                                className="border-right text-center"
                                                            >
                                                                RateShop
                                                            </th>
                                                        )}
                                                        <th className="border-right"></th>
                                                    </tr>
                                                    <tr className="table-main-header-tr">
                                                        <th className="width150" >
                                                            Date
                                                        </th>
                                                        <th className="border-right text-center border-right-1 width100" >
                                                            Demand Score
                                                        </th>
                                                        <th className="width100 ">OOO\Rooms Available</th>
                                                        <th className="width75 text-center ">Left To sell</th>
                                                        <th className="width75 text-center ">AVG LT</th>
                                                        <th className="width75 text-center">On The Books</th>
                                                        <th>Total OCC%</th>
                                                        <th className="text-end">ADR</th>
                                                        <th className="text-center border-right">Rev</th>
                                                        <th className="text-end">RevPAR</th>
                                                        <th className=" border-right">OTB\Block</th>
                                                        <th className="width50 text-center border-right">OTB</th>
                                                        <th className="width100 text-center">8 Week Rolling Avg</th>

                                                        <th className="text-end border-right">ADR</th>
                                                        <th className="text-center">OTB</th>
                                                        <th className="text-end">Rev</th>
                                                        <th className="text-center">AVG LT</th>
                                                        {/*<th className="text-center">AVG Rate</th>*/}

                                                        <th className="text-end border-right">ADR</th>
                                                        <th className="text-center">OTB</th>
                                                        <th className="text-end">Rev</th>
                                                        <th className="text-center">AVG LT</th>
                                                        {/*<th className="text-center">AVG Rate</th>*/}

                                                        <th className="border-right text-center">Rooms</th>
                                                        <th className="text-end">ADR Change</th>
                                                        <th className="text-end">Rev</th>

                                                        <th className="border-right text-center">Rooms</th>
                                                        <th className="text-end">ADR Change</th>
                                                        <th className="text-end">Rev</th>

                                                        <th className="border-right text-center">Rooms</th>
                                                        <th className="text-end">ADR Change</th>
                                                        <th className="text-end">Rev</th>


                                                        <th className="text-center border-right width110">
                                                            <div>
                                                                <Form.Select id={commonService.generateGlobalClickTrackerID("DSDashboard", "pricing-forecast-system-forecast", "")}
                                                                    value={selectedForecast}
                                                                    onChange={(e) => {
                                                                        setSelectedForecast(e.target.value);
                                                                    }}
                                                                >
                                                                    <option value="ema">System Forecast</option>
                                                                    <option value="rms">RMS Forecast</option>
                                                                    <option value="user">USER Forecast</option>
                                                                    <option value="nova">RM Copilot Forecast</option>
                                                                </Form.Select>
                                                                <span style={{ display: "none" }}>
                                                                    {commonService.ForecastTypeDisplayLable(selectedForecast)}
                                                                </span>
                                                            </div>
                                                        </th>
                                                        <th>R28 Avg</th>
                                                        <th className="text-end">Optimal Bar</th>

                                                        {rateShopListData &&
                                                            rateShopListData?.map((x) => {
                                                                if (
                                                                    x.CheckInDate ===
                                                                    moment(rateShopListData?.[0]?.CheckInDate).format(
                                                                        "YYYY-MM-DD"
                                                                    ) &&
                                                                    x.IsSelf === true
                                                                ) {
                                                                    return (
                                                                        <th
                                                                            className="text-end border-right"
                                                                            title={x?.competiterpropertyname}
                                                                            colSpan={2}
                                                                        >
                                                                            {x?.competiterpropertyname?.length > 10
                                                                                ? `${x?.competiterpropertyname?.slice(0, 10)}...`
                                                                                : x?.competiterpropertyname}
                                                                        </th>
                                                                    );
                                                                }
                                                            })}
                                                        {rateShopListData && (
                                                            <>
                                                                <th className="text-end border-right" colSpan={2}>Comp Set Avg</th>
                                                                <th className="text-end">STLY Avg</th>
                                                                <th className="text-end border-end">LY Avg</th>
                                                            </>
                                                        )}

                                                        <th className="border-right text-center">Notes</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loading ? (
                                                        <tr style={{ height: "80px", position: "relative" }}>
                                                            <Loader />
                                                        </tr>
                                                    ) : (
                                                        startDateArrayRef.current?.map((item, index) => {
                                                            dayName = false;
                                                            if (
                                                                moment(new Date(item), "l").format("ddd") === "Fri" ||
                                                                moment(new Date(item), "l").format("ddd") === "Sat"
                                                            ) {
                                                                dayName = true;
                                                            }

                                                            let singlePickupData = pickupFromData?.filter(
                                                                (x) =>
                                                                    moment(x.Dates).format("YYYY-MM-DD") ===
                                                                    moment(item).format("YYYY-MM-DD")
                                                            );

                                                            let threePickupData = threePickupFromData?.filter(
                                                                (x) =>
                                                                    moment(x.Dates).format("YYYY-MM-DD") ===
                                                                    moment(item).format("YYYY-MM-DD")
                                                            );

                                                            let sevenPickupData = sevenPickupFromData?.filter(
                                                                (x) =>
                                                                    moment(x.Dates).format("YYYY-MM-DD") ===
                                                                    moment(item).format("YYYY-MM-DD")
                                                            );

                                                            let singleOTBData = orgData?.filter(
                                                                (x) =>
                                                                    moment(x.Date).format("YYYY-MM-DD") ===
                                                                    moment(item).format("YYYY-MM-DD")
                                                            );

                                                            ooo =
                                                                ooo +
                                                                (singleOTBData?.[0]?.OOO ? singleOTBData?.[0]?.OOO : 0);
                                                            RmsAvailable =
                                                                RmsAvailable +
                                                                (singleOTBData?.[0]?.RoomAvailable
                                                                    ? singleOTBData?.[0]?.RoomAvailable
                                                                    : 0);
                                                            leftToSell =
                                                                leftToSell +
                                                                (singleOTBData?.[0]?.LeftToSell
                                                                    ? singleOTBData?.[0]?.LeftToSell
                                                                    : 0);
                                                            avgleadtime =
                                                                avgleadtime +
                                                                (singleOTBData?.[0]?.avgleadtime
                                                                    ? singleOTBData?.[0]?.avgleadtime
                                                                    : 0);
                                                            otb =
                                                                otb +
                                                                (singleOTBData?.[0]?.OnTheBook
                                                                    ? singleOTBData?.[0]?.OnTheBook
                                                                    : 0);
                                                            occPercentage =
                                                                occPercentage +
                                                                (singleOTBData?.[0]?.TotalOCCPercentage
                                                                    ? singleOTBData?.[0]?.TotalOCCPercentage
                                                                    : 0);
                                                            adr =
                                                                adr +
                                                                (singleOTBData?.[0]?.ADR ? singleOTBData?.[0]?.ADR : 0);
                                                            rev =
                                                                rev +
                                                                (singleOTBData?.[0]?.REV ? singleOTBData?.[0]?.REV : 0);
                                                            revPar =
                                                                revPar +
                                                                (singleOTBData?.[0]?.RevPAR
                                                                    ? singleOTBData?.[0]?.RevPAR
                                                                    : 0);
                                                            groupOTB =
                                                                groupOTB +
                                                                (singleOTBData?.[0]?.OTB ? singleOTBData?.[0]?.OTB : 0);
                                                            groupBlock =
                                                                groupBlock +
                                                                (singleOTBData?.[0]?.Block
                                                                    ? singleOTBData?.[0]?.Block
                                                                    : 0);
                                                            pickupRooms =
                                                                pickupRooms +
                                                                (singlePickupData?.[0]?.RMS
                                                                    ? singlePickupData?.[0]?.RMS
                                                                    : 0);
                                                            pickupAdr =
                                                                pickupAdr +
                                                                (singlePickupData?.[0]?.ADR
                                                                    ? singlePickupData?.[0]?.ADR
                                                                    : 0);
                                                            // --- Prev ---
                                                            // pickupRev =
                                                            //     pickupRev +
                                                            //     (singlePickupData?.[0]?.RMS
                                                            //         ? singlePickupData?.[0]?.RMS
                                                            //         : 0) *
                                                            //     (singlePickupData?.[0]?.ADR
                                                            //         ? singlePickupData?.[0]?.ADR
                                                            //         : 0);

                                                            // --- Current ---
                                                            pickupRev =
                                                                pickupRev +
                                                                (singlePickupData?.[0]?.REV
                                                                    ? singlePickupData?.[0]?.REV
                                                                    : 0);

                                                            if (singlePickupData?.[0]?.ADR) {
                                                                if (singlePickupData?.[0]?.ADR !== 0) {
                                                                    pickupAdrCount = pickupAdrCount + 1;
                                                                }
                                                            }

                                                            sevenPickupRooms =
                                                                sevenPickupRooms +
                                                                (sevenPickupData?.[0]?.RMS
                                                                    ? sevenPickupData?.[0]?.RMS
                                                                    : 0);
                                                            sevenPickupAdr =
                                                                sevenPickupAdr +
                                                                (sevenPickupData?.[0]?.ADR
                                                                    ? sevenPickupData?.[0]?.ADR
                                                                    : 0);
                                                            if (sevenPickupData?.[0]?.ADR) {
                                                                if (sevenPickupData?.[0]?.ADR !== 0) {
                                                                    sevenPickupAdrCount = sevenPickupAdrCount + 1;
                                                                }
                                                            }

                                                            // --- Prev ---
                                                            // sevenPickupRev =
                                                            //     sevenPickupRev +
                                                            //     (sevenPickupData?.[0]?.RMS
                                                            //         ? sevenPickupData?.[0]?.RMS
                                                            //         : 0) *
                                                            //     (sevenPickupData?.[0]?.ADR
                                                            //         ? sevenPickupData?.[0]?.ADR
                                                            //         : 0);

                                                            // --- Current ---
                                                            sevenPickupRev =
                                                                sevenPickupRev +
                                                                (sevenPickupData?.[0]?.REV
                                                                    ? sevenPickupData?.[0]?.REV
                                                                    : 0)



                                                            /*Three Day*/

                                                            threePickupRooms =
                                                                threePickupRooms +
                                                                (threePickupData?.[0]?.RMS
                                                                    ? threePickupData?.[0]?.RMS
                                                                    : 0);
                                                            threePickupAdr =
                                                                threePickupAdr +
                                                                (threePickupData?.[0]?.ADR
                                                                    ? threePickupData?.[0]?.ADR
                                                                    : 0);
                                                            if (threePickupData?.[0]?.ADR) {
                                                                if (threePickupData?.[0]?.ADR !== 0) {
                                                                    threePickupAdrCount = threePickupAdrCount + 1;
                                                                }
                                                            }

                                                            // --- Prev ---
                                                            // threePickupRev =
                                                            //     threePickupRev +
                                                            //     (threePickupData?.[0]?.RMS
                                                            //         ? threePickupData?.[0]?.RMS
                                                            //         : 0) *
                                                            //     (threePickupData?.[0]?.ADR
                                                            //         ? threePickupData?.[0]?.ADR
                                                            //         : 0);

                                                            // --- Current ---
                                                            threePickupRev =
                                                                threePickupRev +
                                                                (threePickupData?.[0]?.REV
                                                                    ? threePickupData?.[0]?.REV
                                                                    : 0);

                                                            let singleForecastData = forecastData?.filter(
                                                                (x) =>
                                                                    moment(x.Dates).format("YYYY-MM-DD") ===
                                                                    moment(item).format("YYYY-MM-DD")
                                                            );

                                                            let singleBarBasedData = barBasedData?.filter(
                                                                (x) =>
                                                                    moment(x.StayDate).format("YYYY-MM-DD") ===
                                                                    moment(item).format("YYYY-MM-DD")
                                                            );

                                                            barBasedOTB =
                                                                barBasedOTB +
                                                                (singleBarBasedData?.[0]?.OTB
                                                                    ? parseInt(singleBarBasedData?.[0]?.OTB)
                                                                    : 0);

                                                            baeBasedRollingAvg =
                                                                baeBasedRollingAvg +
                                                                (singleBarBasedData?.[0]?.["8 Week Rolling AVG"]
                                                                    ? parseInt(
                                                                        singleBarBasedData?.[0]?.["8 Week Rolling AVG"]
                                                                    )
                                                                    : 0);

                                                            let isSelfData = rateShopListData?.filter((x) => {
                                                                if (
                                                                    x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                                    x.IsSelf === true
                                                                ) {
                                                                    return x;
                                                                }
                                                            });

                                                            let SelfDataRateDiff = 0;

                                                            let past_isSelfData = past_rateShopListData?.filter((x) => {
                                                                if (
                                                                    x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                                    x.IsSelf === true
                                                                ) {
                                                                    return x;
                                                                }
                                                            });

                                                            if (past_isSelfData && past_isSelfData.length > 0 && isSelfData && isSelfData.length > 0) {
                                                                let PDRate = past_isSelfData[0]?.Rate ? past_isSelfData[0]?.Rate : 0;
                                                                let Rate = isSelfData[0]?.Rate ? isSelfData[0]?.Rate : 0;
                                                                SelfDataRateDiff = parseInt(PDRate) - parseInt(Rate);
                                                            }




                                                            let rateShoptotal = 0;
                                                            rateShopListData?.map((x) => {
                                                                if (
                                                                    x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                                    x.IsSelf === false
                                                                ) {
                                                                    rateShoptotal = rateShoptotal + parseFloat(x?.Rate);
                                                                }
                                                            });

                                                            let findCompetitorData = rateShopListData?.filter(
                                                                (x) =>
                                                                    x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                                    x.IsSelf === false
                                                            );


                                                            let past_findCompetitorData = past_rateShopListData?.filter(
                                                                (x) =>
                                                                    x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                                    x.IsSelf === false
                                                            );

                                                            let findDataForAvgCount = rateShopListData?.filter(
                                                                (x) =>
                                                                    x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                                    x.IsSelf === false &&
                                                                    parseFloat(x.Rate) > 0
                                                            );

                                                            let avgCompetitor =
                                                                rateShoptotal > 0 && findDataForAvgCount?.length > 0
                                                                    ? Math.round(
                                                                        rateShoptotal / findDataForAvgCount?.length
                                                                    )
                                                                    : 0;


                                                            let past_rateShoptotal = 0;

                                                            past_rateShopListData?.map((x) => {
                                                                if (
                                                                    x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                                    x.IsSelf === false
                                                                ) {
                                                                    past_rateShoptotal = past_rateShoptotal + parseFloat(x?.Rate);
                                                                }
                                                            });

                                                            let past_findDataForAvgCount = past_rateShopListData?.filter(
                                                                (x) =>
                                                                    x.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                                    x.IsSelf === false &&
                                                                    parseFloat(x.Rate) > 0
                                                            );

                                                            let past_avgCompetitor =
                                                                past_rateShoptotal > 0 && past_findDataForAvgCount?.length > 0
                                                                    ? Math.round(
                                                                        past_rateShoptotal / past_findDataForAvgCount?.length
                                                                    )
                                                                    : 0;

                                                            let avgCompetitorRateDiff = 0;


                                                            avgCompetitorRateDiff = parseInt(past_avgCompetitor) - parseInt(avgCompetitor);


                                                            let dataExistsOrNot = rateShopListData?.filter((x) => {
                                                                if (
                                                                    x?.CheckInDate === moment(item).format("YYYY-MM-DD") &&
                                                                    x?.IsSelf === false
                                                                ) {
                                                                    return x;
                                                                }
                                                            });

                                                            let checkEvent = eventListRef.current?.filter((x) => {
                                                                let checkingDate = moment(item);
                                                                let startingDate = moment(x?.startDate);
                                                                let endingDate = moment(x?.endDate);
                                                                if (
                                                                    checkingDate.isSameOrAfter(startingDate) &&
                                                                    checkingDate.isSameOrBefore(endingDate)
                                                                ) {
                                                                    return x;
                                                                }
                                                            });

                                                            let foreCastSpiderTextColor = "";
                                                            let forecastSpiderBorder = "";
                                                            if (
                                                                singleForecastData?.[0]?.RMS <
                                                                singleForecastData?.[0]?.R28AVG
                                                            ) {
                                                                foreCastSpiderTextColor = "redText";
                                                                let R28AvgPercentage =
                                                                    (singleForecastData?.[0]?.R28AVG * 10) / 100;
                                                                let finalValue =
                                                                    singleForecastData?.[0]?.R28AVG - R28AvgPercentage;
                                                                if (singleForecastData?.[0]?.RMS < finalValue) {
                                                                    forecastSpiderBorder = "redBorderTd";
                                                                }
                                                            } else {
                                                                let R28AvgPercentage =
                                                                    (singleForecastData?.[0]?.R28AVG * 10) / 100;
                                                                let finalValue =
                                                                    singleForecastData?.[0]?.R28AVG + R28AvgPercentage;
                                                                if (singleForecastData?.[0]?.RMS > finalValue) {
                                                                    forecastSpiderBorder = "blackBorderTd";
                                                                }
                                                            }

                                                            let checkNoteExists = noteDetail?.notedata?.filter(
                                                                (x) =>
                                                                    moment(x?.datadate).format("YYYY-MM-DD") ===
                                                                    moment(item).format("YYYY-MM-DD")
                                                            );

                                                            let DemandScore = 0;
                                                            let DemandScoreClassName = "demandscorecolor-verylow";
                                                            let LevelMessage = "";

                                                            if (demandScoreData && demandScoreData.length > 0) {
                                                                let fd = demandScoreData.filter((d) => moment(d.StayDate).format("YYYY-MM-DD") === moment(item).format("YYYY-MM-DD"));
                                                                if (fd && fd.length > 0) {
                                                                    DemandScore = fd[0].finaldemandscore ? Math.round(fd[0].finaldemandscore) : 0;

                                                                    if (DemandScore >= demandLevels.veryhigh) {
                                                                        DemandScoreClassName = "demandscorecolor-veryhigh";
                                                                    }
                                                                    else if (DemandScore >= demandLevels.high) {
                                                                        DemandScoreClassName = "demandscorecolor-high";
                                                                    }
                                                                    else if (DemandScore >= demandLevels.moderate) {
                                                                        DemandScoreClassName = "demandscorecolor-moderate";
                                                                    }
                                                                    else if (DemandScore >= demandLevels.low) {
                                                                        DemandScoreClassName = "demandscorecolor-low";
                                                                    }
                                                                    else if (DemandScore >= demandLevels.verylow) {
                                                                        DemandScoreClassName = "demandscorecolor-verylow";
                                                                    }
                                                                    LevelMessage = fd[0].msg
                                                                }
                                                            }

                                                            let STLY_ADR = 0;
                                                            let STLY_OTB = 0;
                                                            let STLY_Revenue = 0;
                                                            let STLY_AVG_Lead_Time = 0;
                                                            let STLY_AVG_Rate = 0;

                                                            let LY_ADR = 0;
                                                            let LY_OTB = 0;
                                                            let LY_Revenue = 0;
                                                            let LY_AVG_Lead_Time = 0;
                                                            let LY_AVG_Rate = 0;

                                                            if (
                                                                STLY_LY_COMSET_Rates &&
                                                                STLY_LY_COMSET_Rates.length > 0
                                                            ) {
                                                                let findByDate = STLY_LY_COMSET_Rates.filter(
                                                                    (x) =>
                                                                        moment(x.dates).format("YYYY-MM-DD") ===
                                                                        moment(item).format("YYYY-MM-DD")
                                                                );
                                                                if (findByDate && findByDate.length > 0) {
                                                                    STLY_ADR = findByDate[0].stlyadr
                                                                        ? findByDate[0].stlyadr
                                                                        : 0;
                                                                    STLY_OTB = findByDate[0].stlyotb
                                                                        ? findByDate[0].stlyotb
                                                                        : 0;
                                                                    STLY_Revenue = findByDate[0].stlyrevenue
                                                                        ? findByDate[0].stlyrevenue
                                                                        : 0;
                                                                    STLY_AVG_Lead_Time = findByDate[0].stlyavgleadtime
                                                                        ? findByDate[0].stlyavgleadtime
                                                                        : 0;
                                                                    STLY_AVG_Rate = findByDate[0].stlyavgrate
                                                                        ? findByDate[0].stlyavgrate
                                                                        : 0;

                                                                    LY_ADR = findByDate[0].lyadr ? findByDate[0].lyadr : 0;
                                                                    LY_OTB = findByDate[0].lyotb ? findByDate[0].lyotb : 0;
                                                                    LY_Revenue = findByDate[0].lyrevenue
                                                                        ? findByDate[0].lyrevenue
                                                                        : 0;
                                                                    LY_AVG_Lead_Time = findByDate[0].lyavgleadtime
                                                                        ? findByDate[0].lyavgleadtime
                                                                        : 0;
                                                                    LY_AVG_Rate = findByDate[0].lyavgrate
                                                                        ? findByDate[0].lyavgrate
                                                                        : 0;

                                                                    if (STLY_ADR > 0) {
                                                                        Total_STLY_ADR_Count = Total_STLY_ADR_Count + 1;
                                                                        Total_STLY_ADR = Total_STLY_ADR + STLY_ADR;
                                                                    }

                                                                    if (STLY_AVG_Lead_Time > 0) {
                                                                        Total_STLY_AVG_Lead_Time_Count =
                                                                            Total_STLY_AVG_Lead_Time_Count + 1;
                                                                        Total_STLY_AVG_Lead_Time =
                                                                            Total_STLY_AVG_Lead_Time + STLY_AVG_Lead_Time;
                                                                    }

                                                                    Total_STLY_OTB = Total_STLY_OTB + STLY_OTB;
                                                                    Total_STLY_Revenue = Total_STLY_Revenue + STLY_Revenue;
                                                                    Total_STLY_AVG_Rate =
                                                                        Total_STLY_AVG_Rate + STLY_AVG_Rate;

                                                                    if (LY_ADR > 0) {
                                                                        Total_LY_ADR_Count = Total_LY_ADR_Count + 1;
                                                                        Total_LY_ADR = Total_LY_ADR + LY_ADR;
                                                                    }

                                                                    if (LY_AVG_Lead_Time > 0) {
                                                                        Total_LY_AVG_Lead_Time_Count =
                                                                            Total_LY_AVG_Lead_Time_Count + 1;
                                                                        Total_LY_AVG_Lead_Time =
                                                                            Total_LY_AVG_Lead_Time + LY_AVG_Lead_Time;
                                                                    }

                                                                    Total_LY_OTB = Total_LY_OTB + LY_OTB;
                                                                    Total_LY_Revenue = Total_LY_Revenue + LY_Revenue;
                                                                    Total_LY_AVG_Rate = Total_LY_AVG_Rate + LY_AVG_Rate;
                                                                }
                                                            }

                                                            return (
                                                                <React.Fragment key={index}>
                                                                    <tr
                                                                        key={index}
                                                                        className={`${dayName ? "backgroundTr" : ""
                                                                            } shadowOnHover`}
                                                                    >
                                                                        <td className="">
                                                                            <div className="d-flex gap-1">
                                                                                <div className="d-flex gap-4">
                                                                                    {commonService.getDateInFormat(
                                                                                        // startDateArrayRef.current[index]
                                                                                        item
                                                                                    )}{" "}
                                                                                    {moment(
                                                                                        // new Date(startDateArrayRef.current[index]),
                                                                                        new Date(item),
                                                                                        "l"
                                                                                    ).format("ddd")}
                                                                                    <div className="d-flex justify-content-between align-items-center gap-2 ticketAlarmReload">
                                                                                        {checkEvent?.length > 0 && (
                                                                                            <img id={commonService.generateGlobalClickTrackerID("DSDashboard", "ticket", item)}
                                                                                                style={{ height: "11px", width: "11px" }}
                                                                                                className="iconcolor"
                                                                                                src={ticket}
                                                                                                alt="ticket"
                                                                                                onClick={() => {
                                                                                                    selectedEventDateRef.current = item;
                                                                                                    eventListPropsRef.current = checkEvent;
                                                                                                    setShowTicketModal(true);
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td className={`width100 border-right border-right-1 text-center demandscorecolorcontainer`}>
                                                                            <>
                                                                                {
                                                                                    LevelMessage ?
                                                                                        <OverlayTrigger
                                                                                            placement="right"
                                                                                            delay={{ show: 250, hide: 2000 }}
                                                                                            overlay={renderTooltip(
                                                                                                LevelMessage,
                                                                                                item
                                                                                            )}
                                                                                        >

                                                                                            <span style={{ cursor: "pointer" }}>{DemandScore}</span>
                                                                                        </OverlayTrigger>
                                                                                        :
                                                                                        <span>{DemandScore}</span>

                                                                                }
                                                                                <div className={`demandscorecolordiv ${DemandScoreClassName}`}></div>
                                                                            </>
                                                                        </td>
                                                                        <td className="width100">
                                                                            {singleOTBData?.[0]?.OOO
                                                                                ? commonService.formateRoom(
                                                                                    singleOTBData?.[0]?.OOO
                                                                                )
                                                                                : 0}{" "}
                                                                            \{" "}
                                                                            {singleOTBData?.[0]?.RoomAvailable
                                                                                ? commonService.formateRoom(
                                                                                    singleOTBData?.[0]?.RoomAvailable
                                                                                )
                                                                                : 0}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            {singleOTBData?.[0]?.LeftToSell
                                                                                ? commonService.formateRoom(
                                                                                    singleOTBData?.[0]?.LeftToSell
                                                                                )
                                                                                : 0}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            {singleOTBData?.[0]?.avgleadtime
                                                                                ? commonService.formateRoom(
                                                                                    singleOTBData?.[0]?.avgleadtime
                                                                                )
                                                                                : 0}
                                                                        </td>
                                                                        <td
                                                                            className="text-primary text-center"
                                                                            value={
                                                                                singleOTBData?.[0]?.OnTheBook
                                                                                    ? commonService.formateRoom(
                                                                                        singleOTBData?.[0]?.OnTheBook
                                                                                    )
                                                                                    : 0
                                                                            }
                                                                        >
                                                                            <span id={commonService.generateGlobalClickTrackerID("DSDashboard", "transient-current-year-on-the-books", item)}
                                                                                className={`${selectedTdIndexRef.current === index
                                                                                    ? "singleDateSummarySpan"
                                                                                    : ""
                                                                                    }`}
                                                                                onClick={(e) => {
                                                                                    singleDateSelectedDateRef.current = item;

                                                                                    handleFilterBtnClick(e);
                                                                                    selectedTdIndexRef.current = index;
                                                                                }}
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                {singleOTBData?.[0]?.OnTheBook
                                                                                    ? singleOTBData?.[0]?.OnTheBook
                                                                                    : 0}
                                                                            </span>
                                                                        </td>

                                                                        <td className={"perbackground TotalOCCPercentage"} value={singleOTBData?.[0]?.TotalOCCPercentage
                                                                            ? singleOTBData?.[0]?.TotalOCCPercentage
                                                                            : 0}>
                                                                            {singleOTBData?.[0]?.TotalOCCPercentage
                                                                                ? singleOTBData?.[0]?.TotalOCCPercentage
                                                                                : 0}
                                                                            %
                                                                        </td>
                                                                        <td
                                                                            className="text-end"
                                                                            value={singleOTBData?.[0]?.ADR}
                                                                        >
                                                                            {singleOTBData?.[0]?.ADR
                                                                                ? commonService.formateAmount(
                                                                                    singleOTBData?.[0]?.ADR
                                                                                )
                                                                                : commonService.formateAmount(0)}
                                                                        </td>
                                                                        <td className="text-end border-right">
                                                                            {singleOTBData?.[0]?.REV
                                                                                ? commonService.formateAmount(
                                                                                    singleOTBData?.[0]?.REV
                                                                                )
                                                                                : commonService.formateAmount(0)}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {singleOTBData?.[0]?.RevPAR
                                                                                ? commonService.formateAmount(
                                                                                    singleOTBData?.[0]?.RevPAR
                                                                                )
                                                                                : commonService.formateAmount(0)}
                                                                        </td>
                                                                        <td
                                                                            className="perbackground perbackground-GroupOTB border-right text-center text-primary"
                                                                            value={commonService.FindPercentageOfValueMaxUpTo100(singleOTBData?.[0]?.OTB, singleOTBData?.[0]?.Block)}
                                                                        >
                                                                            <span id={commonService.generateGlobalClickTrackerID("DSDashboard", "group-otb-block", item)}
                                                                                className={`${selectedTdIndexRef.current === index
                                                                                    ? "singleDateSummarySpan"
                                                                                    : ""
                                                                                    }`}
                                                                                onClick={(e) => {
                                                                                    singleDateSelectedDateRef.current = item;

                                                                                    handleGroupBtnClick(e);
                                                                                    selectedTdIndexRef.current = index;
                                                                                }}
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                {singleOTBData?.[0]?.OTB
                                                                                    ? commonService.formateRoom(
                                                                                        singleOTBData?.[0]?.OTB
                                                                                    )
                                                                                    : 0}
                                                                                \
                                                                                {singleOTBData?.[0]?.Block
                                                                                    ? commonService.formateRoom(
                                                                                        singleOTBData?.[0]?.Block
                                                                                    )
                                                                                    : 0}
                                                                            </span>
                                                                        </td>
                                                                        <td className="border-right text-center">
                                                                            {singleBarBasedData?.[0]?.OTB
                                                                                ? commonService.formateRoom(
                                                                                    singleBarBasedData?.[0]?.OTB
                                                                                )
                                                                                : 0}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            {singleBarBasedData?.[0]?.["8 Week Rolling AVG"]
                                                                                ? commonService.formateRoom(
                                                                                    singleBarBasedData?.[0]?.[
                                                                                    "8 Week Rolling AVG"
                                                                                    ]
                                                                                )
                                                                                : 0}
                                                                        </td>

                                                                        <td className="text-end border-right">
                                                                            {commonService.formateAmount(STLY_ADR)}
                                                                        </td>
                                                                        <td className="text-center">{STLY_OTB}</td>
                                                                        <td className="text-end">
                                                                            {commonService.formateAmount(STLY_Revenue)}
                                                                        </td>
                                                                        <td className="text-center">{STLY_AVG_Lead_Time}</td>

                                                                        <td className="text-end border-right">
                                                                            {commonService.formateAmount(LY_ADR)}
                                                                        </td>
                                                                        <td className="text-center">{LY_OTB}</td>
                                                                        <td className="text-end">
                                                                            {commonService.formateAmount(LY_Revenue)}
                                                                        </td>
                                                                        <td className="text-center">{LY_AVG_Lead_Time}</td>

                                                                        <td
                                                                            className="perbackground perbackground-room text-center border-right"
                                                                            value={singlePickupData?.[0]?.RMS}
                                                                        >
                                                                            {singlePickupData?.[0]?.RMS
                                                                                ? commonService.formateRoom(
                                                                                    singlePickupData?.[0]?.RMS
                                                                                )
                                                                                : 0}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {/* ${pickupFromData?.[index]?.ADR} */}
                                                                            {singlePickupData?.[0]?.ADR
                                                                                ? commonService.formateAmount(
                                                                                    singlePickupData?.[0]?.ADR
                                                                                )
                                                                                : commonService.formateAmount(0)}
                                                                        </td>
                                                                        <td className="text-end">

                                                                            {singlePickupData?.[0]?.REV
                                                                                ? commonService.formateAmount(
                                                                                    parseFloat(singlePickupData?.[0]?.REV)
                                                                                )
                                                                                : commonService.formateAmount(0)}
                                                                        </td>


                                                                        <td
                                                                            className="perbackground perbackground-room text-center border-right"
                                                                            value={threePickupData?.[0]?.RMS}
                                                                        >
                                                                            {threePickupData?.[0]?.RMS
                                                                                ? commonService.formateRoom(
                                                                                    threePickupData?.[0]?.RMS
                                                                                )
                                                                                : 0}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {threePickupData?.[0]?.ADR
                                                                                ? commonService.formateAmount(
                                                                                    threePickupData?.[0]?.ADR
                                                                                )
                                                                                : commonService.formateAmount(0)}
                                                                        </td>
                                                                        <td className="text-end">

                                                                            {threePickupData?.[0]?.REV
                                                                                ? commonService.formateAmount(
                                                                                    parseFloat(threePickupData?.[0]?.REV)
                                                                                )
                                                                                : commonService.formateAmount(0)}
                                                                        </td>





                                                                        <td
                                                                            className="perbackground perbackground-room text-center border-right"
                                                                            value={sevenPickupData?.[0]?.RMS}
                                                                        >
                                                                            {sevenPickupData?.[0]?.RMS
                                                                                ? commonService.formateRoom(
                                                                                    sevenPickupData?.[0]?.RMS
                                                                                )
                                                                                : 0}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {sevenPickupData?.[0]?.ADR
                                                                                ? commonService.formateAmount(
                                                                                    sevenPickupData?.[0]?.ADR
                                                                                )
                                                                                : commonService.formateAmount(0)}
                                                                        </td>
                                                                        <td className="text-end">

                                                                            {sevenPickupData?.[0]?.REV
                                                                                ? commonService.formateAmount(
                                                                                    parseFloat(sevenPickupData?.[0]?.REV)
                                                                                )
                                                                                : commonService.formateAmount(0)}
                                                                        </td>

                                                                        <td className="border-right text-center">
                                                                            <div className="d-flex justify-content-center align-items-center">
                                                                                <lable
                                                                                    className={`${foreCastSpiderTextColor} ${forecastSpiderBorder} m-0`}
                                                                                    style={{ padding: "2px" }}
                                                                                >
                                                                                    {singleForecastData?.[0]?.RMS
                                                                                        ? commonService.formateRoom(
                                                                                            singleForecastData?.[0]?.RMS
                                                                                        )
                                                                                        : 0}
                                                                                </lable>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            {singleForecastData?.[0]?.R28AVG
                                                                                ? commonService.formateRoom(
                                                                                    singleForecastData?.[0]?.R28AVG
                                                                                )
                                                                                : 0}
                                                                        </td>
                                                                        <td className="text-end">
                                                                            {singleForecastData?.[0]?.["Optimal Bar"]
                                                                                ? `${commonService.formateAmount(
                                                                                    singleForecastData?.[0]?.["Optimal Bar"]
                                                                                )}`
                                                                                : `${commonService.formateAmount(0)}`}
                                                                        </td>

                                                                        {rateShopListData && (
                                                                            <>
                                                                                <td
                                                                                    className={`text-end border-right ${isSelfData?.[0]?.Rate < avgCompetitor
                                                                                        ? "greenText"
                                                                                        : "redText"
                                                                                        }`}
                                                                                >
                                                                                    {
                                                                                        isSelfData?.length > 0 ?
                                                                                            <>
                                                                                                {parseInt(isSelfData[0]?.RateStatusCode) === 201 ? (
                                                                                                    <img
                                                                                                        className="cursorPointer"
                                                                                                        src={soldOutIcon}
                                                                                                        alt="soldout"
                                                                                                    />
                                                                                                ) : (

                                                                                                    isSelfData[0]?.Rate
                                                                                                        ? <span title={`${parseFloat(isSelfData[0]?.Rate) <= 0 && isSelfData[0]?.RateStatusDesc ? isSelfData[0]?.RateStatusDesc : ""}`}>{`${commonService.formateAmount(Math.round(isSelfData[0]?.Rate))}`}</span>
                                                                                                        : <span title={`${isSelfData[0]?.RateStatusDesc ? isSelfData[0]?.RateStatusDesc : ""}`}>{`${commonService.formateAmount(0)}`}</span>

                                                                                                )}
                                                                                            </>
                                                                                            :
                                                                                            commonService.formateAmount(0)
                                                                                    }
                                                                                </td>
                                                                                <td className={`text-end fontsize10px minwidth30px ${SelfDataRateDiff ? SelfDataRateDiff > 0 ? "greenText" : "redText" : ""}`}>{SelfDataRateDiff ? commonService.formateAmount(SelfDataRateDiff) : ""}</td>
                                                                            </>
                                                                        )}
                                                                        {rateShopListData && (
                                                                            <>
                                                                                <td id={commonService.generateGlobalClickTrackerID("DSDashboard", "td-onclick", item)}
                                                                                    className="text-end cursorPointer border-right"
                                                                                    onClick={() => {
                                                                                        setClickedDate(item);
                                                                                        setToolsSummaryModal(true);
                                                                                    }}
                                                                                >
                                                                                    {avgCompetitor
                                                                                        ? `${commonService.formateAmount(
                                                                                            avgCompetitor
                                                                                        )}`
                                                                                        : `${commonService.formateAmount(0)}`}
                                                                                </td>
                                                                                <td className={`text-end fontsize10px minwidth30px ${avgCompetitorRateDiff ? avgCompetitorRateDiff > 0 ? "greenText" : "redText" : ""}`}>{avgCompetitorRateDiff ? commonService.formateAmount(avgCompetitorRateDiff) : ""}</td>
                                                                                <td className="text-end">
                                                                                    {commonService.formateAmount(STLY_AVG_Rate)}
                                                                                </td>
                                                                                <td className="text-end border-end">
                                                                                    {commonService.formateAmount(LY_AVG_Rate)}
                                                                                </td>
                                                                            </>
                                                                        )}



                                                                        <td className="border-right">
                                                                            <div>
                                                                                {checkNoteExists?.length > 0 ? (
                                                                                    <img id={commonService.generateGlobalClickTrackerID("DSDashboard", "note", item)}
                                                                                        className="cursorPointer"
                                                                                        src={darkNoteIcon}
                                                                                        onClick={() => {
                                                                                            clickedDateForNote.current = item;
                                                                                            setShowNoteSidebar(true);
                                                                                        }}
                                                                                        alt="note"
                                                                                    />
                                                                                ) : (
                                                                                    <img id={commonService.generateGlobalClickTrackerID("DSDashboard", "note", item)}
                                                                                        className="cursorPointer"
                                                                                        src={NoteIcon}
                                                                                        onClick={() => {
                                                                                            clickedDateForNote.current = item;
                                                                                            setShowNoteSidebar(true);
                                                                                        }}
                                                                                        alt="note"
                                                                                    />
                                                                                )}

                                                                                <div style={{ display: "none" }}>
                                                                                    {checkNoteExists?.map((item, index) => {
                                                                                        return (
                                                                                            <>
                                                                                                <span>{`${item?.displayname
                                                                                                    } - ${htmlToText(
                                                                                                        item?.widgetnotes
                                                                                                    )}`}</span>{" "}
                                                                                                <br />
                                                                                            </>
                                                                                        );
                                                                                    })}
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>

                                                                    {index === startDateArrayRef.current?.length - 1 && (
                                                                        <tr className="shadowOnHover">
                                                                            <td className="boldTd">Total</td>
                                                                            <td className="boldTd border-right text-center">{parseInt(metrics.avgScore ? metrics.avgScore : 0)}</td>
                                                                            <td className="boldTd">
                                                                                {commonService.formateRoom(ooo)} \{" "}
                                                                                {commonService.formateRoom(RmsAvailable)}
                                                                            </td>
                                                                            <td className="boldTd text-center">
                                                                                {commonService.formateRoom(leftToSell)}
                                                                            </td>
                                                                            <td className="boldTd text-center">
                                                                                {commonService.formateRoom(avgleadtime)}
                                                                            </td>
                                                                            <td className="boldTd text-center">
                                                                                {commonService.formateRoom(otb)}
                                                                            </td>
                                                                            <td className="boldTd">
                                                                                {RmsAvailable > 0
                                                                                    ? `${Math.round((otb / RmsAvailable) * 100)}%`
                                                                                    : "0%"}
                                                                            </td>
                                                                            <td className="boldTd text-end">
                                                                                {rev > 0 && otb > 0
                                                                                    ? `${commonService.formateAmount(
                                                                                        parseInt(rev / otb)
                                                                                    )}`
                                                                                    : `${commonService.formateAmount(0)}`}
                                                                            </td>
                                                                            <td className="boldTd text-end">
                                                                                {commonService.formateAmount(rev)}
                                                                            </td>
                                                                            <td className="boldTd text-end">
                                                                                {revPar > 0
                                                                                    ? `${commonService.formateAmount(
                                                                                        parseInt(revPar / diffDays)
                                                                                    )}`
                                                                                    : `${commonService.formateAmount(0)}`}
                                                                            </td>
                                                                            <td className="boldTd text-center border-right">
                                                                                {commonService.formateRoom(groupOTB)}/
                                                                                {commonService.formateRoom(groupBlock)}
                                                                            </td>
                                                                            <td className="boldTd text-center border-right">
                                                                                {commonService.formateRoom(barBasedOTB)}
                                                                            </td>
                                                                            <td className="boldTd text-center">
                                                                                {commonService.formateRoom(baeBasedRollingAvg)}
                                                                            </td>

                                                                            <td className="boldTd text-end border-right">
                                                                                {Total_STLY_OTB > 0
                                                                                    ? commonService.formateAmount(
                                                                                        safeDivide(Total_STLY_Revenue, Total_STLY_OTB)
                                                                                    )
                                                                                    : commonService.formateAmount(0)}
                                                                                {/* {Total_STLY_ADR > 0
                                                                ? commonService.formateAmount(
                                                                    parseInt(
                                                                        Total_STLY_ADR / Total_STLY_ADR_Count
                                                                    )
                                                                )
                                                                : commonService.formateAmount(0)} */}
                                                                            </td>
                                                                            <td className="boldTd text-center">
                                                                                {Total_STLY_OTB}
                                                                            </td>
                                                                            <td className="boldTd text-end">
                                                                                {commonService.formateAmount(Total_STLY_Revenue)}
                                                                            </td>
                                                                            <td className="boldTd text-center">
                                                                                {Total_STLY_AVG_Lead_Time > 0
                                                                                    ? parseInt(
                                                                                        Total_STLY_AVG_Lead_Time /
                                                                                        Total_STLY_AVG_Lead_Time_Count
                                                                                    )
                                                                                    : 0}
                                                                            </td>

                                                                            <td className="boldTd text-end border-right">
                                                                                {Total_LY_OTB > 0
                                                                                    ? commonService.formateAmount(
                                                                                        safeDivide(Total_LY_Revenue, Total_LY_OTB)
                                                                                    )
                                                                                    : commonService.formateAmount(0)}
                                                                                {/* {Total_LY_ADR > 0
                                                                ? commonService.formateAmount(
                                                                    parseInt(Total_LY_ADR / Total_LY_ADR_Count)
                                                                )
                                                                : commonService.formateAmount(0)} */}
                                                                            </td>
                                                                            <td className="boldTd text-center">
                                                                                {Total_LY_OTB}
                                                                            </td>
                                                                            <td className="boldTd text-end">
                                                                                {commonService.formateAmount(Total_LY_Revenue)}
                                                                            </td>
                                                                            <td className="boldTd text-center">
                                                                                {Total_LY_AVG_Lead_Time > 0
                                                                                    ? parseInt(
                                                                                        Total_LY_AVG_Lead_Time /
                                                                                        Total_LY_AVG_Lead_Time_Count
                                                                                    )
                                                                                    : 0}
                                                                            </td>

                                                                            {/* 1 Day Pickup */}
                                                                            <td className="boldTd text-center border-right">
                                                                                {/* {commonService.formateRoom(pickupRooms)} */}
                                                                                {commonService.formateRoom(pickupFromDataTotal?.pick_rms)}
                                                                            </td>
                                                                            <td className="boldTd text-end">
                                                                                {/* {pickupAdr > 0
                                                                ? commonService.formateAmount(
                                                                    parseInt(pickupAdr / pickupAdrCount)
                                                                )
                                                                : commonService.formateAmount(0)} */}
                                                                                {/* {pickupRev > 0 && pickupRooms > 0
                                                                ? commonService.formateAmount(
                                                                    parseInt(pickupRev / pickupRooms)
                                                                )
                                                                : commonService.formateAmount(0)} */}
                                                                                {commonService.formateAmount(pickupFromDataTotal?.pick_adr)}
                                                                            </td>
                                                                            <td className="boldTd text-end">
                                                                                {commonService.formateAmount(pickupFromDataTotal?.pick_rev)}
                                                                            </td>

                                                                            {/* 3 Day Pickup */}
                                                                            <td className="boldTd text-center border-right">
                                                                                {/* {commonService.formateRoom(threePickupRooms)} */}
                                                                                {commonService.formateRoom(threePickupFromDataTotal?.pick_rms)}
                                                                            </td>
                                                                            <td className="boldTd text-end">
                                                                                {/* {threePickupAdr > 0
                                                                ? commonService.formateAmount(
                                                                    parseInt(
                                                                        threePickupAdr / threePickupAdrCount
                                                                    )
                                                                )
                                                                : commonService.formateAmount(0)} */}
                                                                                {/* {threePickupRev > 0 && threePickupRooms > 0
                                                                ? commonService.formateAmount(
                                                                    parseInt(
                                                                        threePickupRev / threePickupRooms
                                                                    )
                                                                )
                                                                : commonService.formateAmount(0)} */}
                                                                                {commonService.formateAmount(threePickupFromDataTotal?.pick_adr)}
                                                                            </td>
                                                                            <td className="boldTd text-end">
                                                                                {/* {commonService.formateAmount(threePickupRev)} */}
                                                                                {commonService.formateAmount(threePickupFromDataTotal?.pick_rev)}
                                                                            </td>


                                                                            {/* 7 Day Pickup */}
                                                                            <td className="boldTd text-center border-right">
                                                                                {/* {commonService.formateRoom(sevenPickupRooms)} */}
                                                                                {commonService.formateRoom(sevenPickupFromDataTotal?.pick_rms)}
                                                                            </td>
                                                                            <td className="boldTd text-end">
                                                                                {/* {sevenPickupAdr > 0
                                                                ? commonService.formateAmount(
                                                                    parseInt(
                                                                        sevenPickupAdr / sevenPickupAdrCount
                                                                    )
                                                                )
                                                                : commonService.formateAmount(0)} */}
                                                                                {/* {sevenPickupRooms > 0 && sevenPickupRev > 0
                                                                ? commonService.formateAmount(
                                                                    parseInt(
                                                                        sevenPickupRev / sevenPickupRooms
                                                                    )
                                                                )
                                                                : commonService.formateAmount(0)} */}
                                                                                {commonService.formateAmount(sevenPickupFromDataTotal?.pick_adr)}
                                                                            </td>
                                                                            <td className="boldTd text-end">
                                                                                {/* {commonService.formateAmount(sevenPickupRev)} */}
                                                                                {commonService.formateAmount(sevenPickupFromDataTotal?.pick_rev)}
                                                                            </td>

                                                                            <td className="boldTd border-right"></td>
                                                                            <td className="boldTd"></td>
                                                                            <td className="boldTd"></td>
                                                                            <td className="boldTd"></td>
                                                                            <td className="boldTd"></td>

                                                                            <td className="boldTd"></td>
                                                                        </tr>
                                                                    )}
                                                                </React.Fragment>
                                                            );
                                                        })
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    {
                       api !== 0 && ( 
                           <Comments
                               widgetDetails={para}
                               // widgetDetails={{
                               //     asOfDate: asOfDate,
                               //     propertyDetail: {
                               //         propertyid: propertyDetailFromRTK?.propertyid || "",
                               //         propertyname: propertyDetailFromRTK?.propertyname || "",
                               //     },
                               //     widgetId: 999994,
                               //     rowTitle: "Parity Check",
                               //     associationtype: "Parity Check",
                               //     widgetname: "Parity Check",
                               //     snapshottitle: "Parity Check",
                               // }}
                               editorId={"DemandScoreDashboard"}
                           />
                       )
                    }
                </Container>
            ) : (
                <Container>
                    <div className="d-flex justify-content-center">
                        <h5>Please Select Property</h5>
                    </div>
                </Container>
            )}

            <Overlay
                show={ONTHEBOOKS.IsDisplay}
                target={ONTHEBOOKS.Target}
                placement={ONTHEBOOKS.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                    style={{ zIndex: 11 }}
                >
                    <div className="horizontal-menu-option active">
                        <SingleDateSummaryModal
                            closeModal={closeSingleDate}
                            asOfDate={selectAsOfDate ? selectAsOfDate : asOfDate}
                            selectedDate={singleDateSelectedDateRef.current}
                            // pickupDate={
                            //   selectPickupDate
                            //     ? selectPickupDate
                            //     : singleDatePickupDateRef.current
                            // }
                            pickupDate={
                                selectSevenPickupDate
                                    ? selectSevenPickupDate
                                    : sevenMaxDateRef.current
                            }
                            propertyDetail={{ propertyCode: propertyDetailFromRTK?.propertycode }}
                        />
                    </div>
                </Popover>
            </Overlay>

            <Overlay
                show={groupModal.IsDisplay}
                target={groupModal.Target}
                placement={groupModal.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                >
                    <div className="horizontal-menu-option active singleDayGroupSummary">
                        <SingleDayGroupModal
                            closeModal={closeGroupDate}
                            asOfDate={selectAsOfDate ? selectAsOfDate : asOfDate}
                            selectedDate={singleDateSelectedDateRef.current}
                            propertyCode={propertyDetailFromRTK?.propertycode}
                        />
                    </div>
                </Popover>
            </Overlay>
            {showNoteSidebar && (
                <WidgetNote
                    show={showNoteSidebar}
                    handleClose={closeNoteSideBar}
                    // widgetId={para?.widgetId}
                    widgetId={0}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={"Demand Score"}
                    dateForNote={clickedDateForNote.current}
                />
            )}
            {addNoteModal && (
                <AddWidgetModal
                    showModal={addNoteModal}
                    closeModal={closeNoteModal}
                    // widgetId={para?.widgetId}
                    widgetId={0}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={"Demand Score"}
                />
            )}
            {widgetModal && (
                <Non_WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    non_widgetname={"Demand Score"}
                />
            )}
            {flagModal && (
                <FlagPopup
                    showModal={flagModal}
                    closeModal={() => setFlagModal(false)}
                    data={flagModalData}
                />
            )}
            {showToolsSummaryModal && (
                <ToolsSummaryModal
                    showToolsSummaryModal={showToolsSummaryModal}
                    closeToolsSummaryModal={closeToolsSummaryModal}
                    selectedDate={ClickedDate}
                    propertyDetail={propertyDetailFromRTK}
                />
            )}

            {showTicketModal && (
                <EventViewModal
                    showModal={showTicketModal}
                    closeModal={closeTicketModal}
                    eventDetails={eventListPropsRef.current}
                    selectedDate={selectedEventDateRef.current}
                    getEventList={getEventList}
                />
            )}
        </div>
    );
};

export default DSDashboard;
